<template>
  <div>
    <label v-if="label || $slots.label" :for="name" class="input-label">
      <slot name="label" :required="required" :attrs-name="name"
        >{{ label }} <span v-if="required" class="required-input">*</span></slot
      >
    </label>
    <div class="relative">
      <input
        :id="`id_${name}`"
        v-model="value"
        :type="type"
        :name="name"
        :placeholder="$attrs.placeholder"
        :disabled="disabled"
        class="input-base"
        :class="{
          'border-gray-300 element-focus': !displayedError,
          'input-error': displayedError,
          'input-disabled': disabled,
          [classWidth]: true,
          [classExtra]: true,
        }"
      />
      <div
        v-if="displayedError"
        class="absolute inset-y-0 right-0 pr-3 flex items-center pointer-events-none"
      >
        <SolidExclamationCircleIcon class="h-5 w-5 text-red-500" />
      </div>
    </div>
    <p
      v-if="displayedError || help"
      class="mt-1 text-sm"
      :class="{
        'text-gray-500': !displayedError,
        'text-red-600': displayedError,
      }"
    >
      {{ displayedError || help }}
    </p>
  </div>
</template>

<script>
import { computed } from 'vue'
import { useFieldValidation } from '@/api/useValidation'

export default {
  name: 'TInput',
  props: {
    name: {
      type: String,
      default: '',
    },
    validator: {
      type: String,
      default: 'validator',
    },
    label: {
      type: String,
      default: '',
    },
    modelValue: {
      type: [Number, String],
      default: '',
    },
    error: {
      type: [String, Array, Object],
      default: '',
    },
    type: {
      type: String,
      default: 'text',
    },
    help: {
      type: String,
      default: '',
    },
    required: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    classExtra: {
      type: String,
      default: '',
    },
    classWidth: {
      type: String,
      default: 'w-full',
    },
  },
  emits: ['update:modelValue'],
  setup(props, context) {
    const value = computed({
      get() {
        return props.modelValue
      },
      set(value) {
        context.emit('update:modelValue', value)
      },
    })
    return {
      value,
      ...useFieldValidation(props),
    }
  },
}
</script>
